import React, { useState, useEffect } from "react";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useSubheader } from "../../../_metronic/layout";
import AccountInformation from "./AccountInformation";
import { ProfileOverview } from "./ProfileOverview";
import ChangePassword from "./ChangePassword";
import PersonaInformation from "./PersonaInformation";
import EmailSettings from "./EmailSettings";
import { ProfileCard } from "./components/ProfileCard";
import { toast } from "react-toastify";
import { toastOption } from "../../../_metronic/_helpers";
import { updateProfile } from "./_redux/authCrud";
import { getUserByToken } from "../Auth/_redux/authCrud";
import { put, takeLatest } from "redux-saga/effects";
import * as auth from "../Auth/_redux/authRedux";

export default function UserProfilePage({ history }) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("User profile");

  const dispatch = useDispatch();

  const user = useSelector(({ auth }) => auth.user, shallowEqual);

  const refreshState = (result) => {
    const { setUser } = auth.actions;
    getUserByToken().then((res) => {
      dispatch(setUser(res.data));
    });
    history.push("/user-profile");
    toast.success(result.data.message, toastOption);
  };

  const saveAdmin = (values) => {
    updateProfile({ ...values })
      .then((res) => {
        refreshState(res);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Gagal update profile", toastOption);
      });
  };

  useEffect(() => {
    delete user.password;
  }, []);

  return (
    <>
      {/* <LoadingAnimation open={loading} /> */}
      <ProfileCard
        userAdmin={user}
        updateAdmin={saveAdmin}
        // logoutOthers={logoutOthersFunc}
      />
      {/* <div className="flex-row-fluid ml-lg-8">
        <Switch>
          <Redirect
            from="/user-profile"
            exact={true}
            to="/user-profile/profile-overview"
          />
          <Route
            path="/user-profile/profile-overview"
            component={ProfileOverview}
          />
          <Route
            path="/user-profile/account-information"
            component={AccountInformation}
          />
          <Route
            path="/user-profile/change-password"
            component={ChangePassword}
          />
          <Route
            path="/user-profile/email-settings"
            component={EmailSettings}
          />
          <Route
            path="/user-profile/personal-information"
            component={PersonaInformation}
          />
        </Switch>
      </div> */}
    </>
  );
}
